import React from 'react';
import Joyride, { STATUS } from 'react-joyride';

class Tour extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            run: false,
            steps: [
                {
                    content: (
                        <div className="text-center">
                            <h4 className="font-weight-bold text-white mb-2">Welcome to FastaFX!</h4>
                            <p className="mb-0 text-white-60">Let's take a quick tour to show you how to trade and win.</p>
                        </div>
                    ),
                    placement: 'center',
                    target: 'body',
                    disableBeacon: true,
                },
                {
                    content: (
                        <div className="text-left">
                            <h5 className="font-weight-bold text-white">1. Deposit Funds</h5>
                            <p className="mb-0 text-white-60">Click here to top up your wallet via M-Pesa. You need funds to start trading.</p>
                        </div>
                    ),
                    placement: 'bottom',
                    target: '.header-wallet-btn'
                },
                {
                    content: (
                        <div className="text-left">
                            <h5 className="font-weight-bold text-white">2. Watch the Graph Direction</h5>
                            <p className="mb-0 text-white-60">The graph climbs and drops as it progresses!</p>
                        </div>
                    ),
                    placement: 'bottom',
                    target: '.game-holder', // Targeting the card wrapper
                },
                {
                    content: (
                        <div className="text-left">
                            <h5 className="font-weight-bold text-white">3. Place Your Bet</h5>
                            <p className="mb-0 text-white-60">Enter your amount and click <b>Up arrow button</b> (Green) to bet the graph will rise/Go up, or <b>Down arrow button</b> (Red) to bet the graph will drop/Go down.</p>
                        </div>
                    ),
                    placement: 'top',
                    target: '.bet-controlar'
                },
                {
                    content: (
                        <div className="text-center">
                            <h4 className="font-weight-bold text-white mb-2">Watch & Win in 10 Secs!</h4>
                            <p className="mb-0 text-white-60">Confirm your trade instantly. if the graph moves your way, you win and vice versa!</p>
                        </div>
                    ),
                    placement: 'center',
                    target: 'body',
                },
                {
                    content: (
                        <div className="text-center">
                            <h4 className="font-weight-bold text-white mb-2">WINNING TIP!</h4>
                            <p className="mb-0 text-white-60">Follow Trends: It is often safer to trade with the graph's momentum than against it.</p>
                        </div>
                    ),
                    placement: 'center',
                    target: 'body',
                },
            ],
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.run && !prevProps.run) {
            this.setState({ run: true });
        }
    }

    handleJoyrideCallback = (data) => {
        const { status } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            this.setState({ run: false });
            if (this.props.onFinish) {
                this.props.onFinish();
            }
        }
    };

    render() {
        return (
            <Joyride
                callback={this.handleJoyrideCallback}
                continuous={true}
                run={this.state.run}
                scrollToFirstStep={true}
                showProgress={true}
                showSkipButton={true}
                steps={this.state.steps}
                styles={{
                    options: {
                        arrowColor: '#1e293b',
                        backgroundColor: 'rgba(30, 41, 59,0.92)',
                        overlayColor: 'rgba(15, 23, 42, 0.85)',
                        primaryColor: 'rgb(242 103 34)', // Emerald green
                        textColor: '#fff',
                        width: 350,
                        zIndex: 10000,
                    },
                    tooltipContainer: {
                        textAlign: 'left',
                    },
                    buttonNext: {
                        backgroundColor: 'rgb(242 103 34)',
                        borderRadius: 8,
                        color: '#fff',
                        fontWeight: 'bold',
                        outline: 'none',
                    },
                    buttonBack: {
                        color: '#94a3b8',
                        marginRight: 10,
                    },
                }}
            />
        );
    }
}

export default Tour;
